module.exports = {"admin":[{"name":"Modules Master","icon":"","route":"/"},{"name":"Sections Master","icon":"","route":"/sections"},{"name":"Sub Sections Master","icon":"","route":"/subSections"}],"customer":[{"name":"Modules","icon":"","route":"/userModules"},{"name":"Categories","icon":"","route":"/userCategories"},{"name":"Customer Master","icon":"","route":"/userSections"}]}


//////////////////
// WEBPACK FOOTER
// ./screens/NavBar/NavMenuJson.json
// module id = 1159
// module chunks = 66